export enum ColorType {
  PRIMARY = 'primary',
  WARNING = 'warning',
  DANGER = 'danger',
  SUCCESS = 'success',
  SECONDARY = 'secondary',
  INFO = 'info',
  WHITE = 'white',
  TRANSPARENCY = 'transparency'
}
